import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "compact", "disabled", "children", "kind", "direction", "alignment", "gap", "style"];
import React, { useMemo } from 'react';
import classNames from 'classnames';
import { ButtonGroupContext } from './ButtonGroupContext';
var ButtonGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    _props$compact = props.compact,
    compact = _props$compact === void 0 ? false : _props$compact,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    children = props.children,
    _props$kind = props.kind,
    kind = _props$kind === void 0 ? 'primary' : _props$kind,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'horizontal' : _props$direction,
    _props$alignment = props.alignment,
    alignment = _props$alignment === void 0 ? 'ltr' : _props$alignment,
    _props$gap = props.gap,
    gap = _props$gap === void 0 ? 8 : _props$gap,
    style = props.style,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  var buttonGroupStyle = typeof gap === 'number' ? {
    gap: gap + "px"
  } : {};

  // const styleGenerator = (index: number) => {
  //   if (direction === 'horizontal') {
  //     if (alignment === 'rtl') {
  //       return {
  //         ...style,
  //         marginRight: index === 0 ? 0 : gap,
  //       };
  //     } else {
  //       return {
  //         ...style,
  //         marginLeft: index === 0 ? 0 : gap,
  //       };
  //     }
  //   } else {
  //     if (alignment === 'rtl') {
  //       return {
  //         ...style,
  //         marginBottom: index === 0 ? 0 : gap,
  //       };
  //     } else {
  //       return {
  //         ...style,
  //         marginTop: index === 0 ? 0 : gap,
  //       };
  //     }
  //   }
  // }

  var context = useMemo(function () {
    return {
      compact: compact,
      disabled: disabled,
      kind: kind
    };
  }, [compact, disabled, kind]);
  var btnGroupClsNames = classNames("ap-btn-group", className, {
    vertical: direction === 'vertical',
    horizontal: direction === 'horizontal',
    rtl: alignment === 'rtl'
  });
  return /*#__PURE__*/React.createElement(ButtonGroupContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    role: "group",
    className: btnGroupClsNames,
    style: _extends({}, buttonGroupStyle)
  }, restProps), children));
});
ButtonGroup.displayName = "ButtonGroup";
export default ButtonGroup;